import React from "react";
import { FlexRowSB } from "../../../../constant/CustomeStyle";
import { BarChart } from "./BarChart";
import { PieChart } from "./PieChart";

const Dashboard = () => {
  return (
    <div style={{ marginBottom: 30, marginRight: 30 }}>
      <div
        style={{
          fontSize: 20,
          fontFamily: "Poppins",
          textAlign: "left",
        }}
      >
        Dashboard
      </div>

      <div style={{ marginTop: 20, paddingBottom: 20 }}>
        <FlexRowSB>
          <div
            style={{
              width: 600,
              padding: 5,
              background: "#FFF",
              borderRadius: 15,
              height: 400,
            }}
          >
            <BarChart />
          </div>
          <div
            style={{
              width: 600,
              padding: 5,
              background: "#FFF",
              borderRadius: 15,
              height: 400,
            }}
          >
            <PieChart />
          </div>
        </FlexRowSB>
      </div>
    </div>
  );
};

export default Dashboard;
